export enum InventorySystem {
  Bokun = 'Bokun',
  Liva = 'Liva'
}
